<template>
  <div>
    <v-row v-if="member!==null" class="px-5">
      <!--      <v-col cols="8" class="d-flex" align-self="center">-->
      <!--        <span class="font-weight-normal black&#45;&#45;text">{{ memberQuantity }} <span v-html="MIXIN_MULTIPLICATION_SIGN"></span> Household member residing in the same household 18 years old and above</span>-->
      <!--      </v-col>-->
      <!--      <v-col cols="4" class="text-right text-hover">-->
      <!--        &lt;!&ndash; Increase Quantity &ndash;&gt;-->
      <!--        <div-->
      <!--          class="text-hover mx-2 align-center d-inline quantity"-->
      <!--          @mouseenter="hover = true"-->
      <!--          @mouseleave="hover = false"-->
      <!--          @click="decrease"-->
      <!--        >-->
      <!--          <v-icon small :color="hover ? 'accent' : 'grey'">mdi-minus</v-icon>-->
      <!--        </div>-->
      <!--        &lt;!&ndash; Decrease Quantity &ndash;&gt;-->
      <!--        <div-->
      <!--          class="text-hover align-center d-inline quantity"-->
      <!--          @mouseenter="hover = true"-->
      <!--          @mouseleave="hover = false"-->
      <!--          @click="increase"-->
      <!--        >-->
      <!--          <v-icon small :color="hover ? 'accent' : 'grey'">mdi-plus</v-icon>-->
      <!--        </div>-->
      <!--      </v-col>-->
      <!--      -->
    </v-row>
    <!-- <v-row :class="[ toggle ? 'item-row-active' : '', hover ? 'item-row' : '', 'px-5' ]"> -->
    <v-row class="px-5">
      <v-col cols="8" class="d-flex" align-self="center">
        <span class="font-weight-bold">{{ quantity }} <span v-html="MIXIN_MULTIPLICATION_SIGN"></span> {{ name }}</span>
        <div
            v-if="!isMerchantPage"
            class="text-hover mx-2 align-center d-flex quantity"
            @mouseenter="quantityHover = true"
            @mouseleave="quantityHover = false"
            @click="decreaseQuantity"
        >
          <v-icon small :color="quantityHover ? 'accent' : 'grey'">mdi-minus</v-icon>
        </div>
        <div
            v-if="!isMerchantPage"
            class="text-hover align-center d-flex quantity"
            @mouseenter="quantityHover = true"
            @mouseleave="quantityHover = false"
            @click="increaseQuantity"
        >
          <v-icon small :color="quantityHover ? 'accent' : 'grey'">mdi-plus</v-icon>
        </div>
      </v-col>
      <!-- <v-col cols="4" class="text-right text-hover" @click="toggle = !toggle" @mouseenter="hover = true" @mouseleave="hover = false"> -->
      <v-col cols="4" class="text-right text-hover">
        <span class="price black--text">{{ (amount * quantity) | numFormat('0,0.00') }}</span>
        <!-- <v-icon :color="toggle ? 'accent' : '#0e6ccd'" class="text-hover">{{ toggle ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon> -->
      </v-col>
    </v-row>
    <!-- <v-row v-if="toggle" class="black--text font-weight-regular px-5 mx-5 py-3"> -->
    <v-row class="black--text font-weight-regular px-5 mx-5 pb-2">
      <span class="pre-wrap">{{ description }}</span>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "SummaryItemRow",
  props: {
    quantity: { type: Number, default: 0 },
    name: { type: String, default: '' },
    amount: { type: Number, default: 0 },
    description: { type: String, default: '' },
    member: { default: null }
  },
  data: () => ({
    hover: false,
    toggle: false,
    // hover: false,
    quantityHover: false
  }),
  computed: {
    memberQuantity() {
      if (this.$route.name == 'ShopCheckout')
        return this.$store.getters['cart/memberQuantity']
      else if (this.$route.name == 'ShopMerchantCheckout')
        return this.$store.getters['merchantCart/memberQuantity']
      else
        return this.$store.getters['promoCart/memberQuantity']
    },
    isMerchantPage() {
      /**
       * This is just a hotfix
       * Tasks: Disable adding the plan for /promo
       */
      return this.$route.name === "ShopMerchantCheckout";
    }
  },
  methods: {
    increaseQuantity() {
      if (this.$route.name == 'ShopCheckout')
        this.$store.commit('cart/increaseQuantity')
      else if (this.$route.name == 'ShopMerchantCheckout')
        this.$store.commit('merchantCart/increaseQuantity')
      else
        this.$store.commit('promoCart/increaseQuantity')
    },
    decreaseQuantity() {
      if (this.$route.name == 'ShopCheckout')
        this.$store.commit('cart/decreaseQuantity')
      else if (this.$route.name == 'ShopMerchantCheckout')
        this.$store.commit('merchantCart/decreaseQuantity')
      else
        this.$store.commit('promoCart/decreaseQuantity')
    },
    increase() {
      if (this.$route.name == 'ShopCheckout')
        this.$store.commit('cart/increaseMemberQuantity')
      else if (this.$route.name == 'ShopMerchantCheckout')
        this.$store.commit('merchantCart/increaseMemberQuantity')
      else
        this.$store.commit('promoCart/increaseMemberQuantity')
    },
    decrease() {
      if (this.$route.name == 'ShopCheckout')
        this.$store.commit('cart/decreaseMemberQuantity')
      else if (this.$route.name == 'ShopMerchantCheckout')
        this.$store.commit('merchantCart/decreaseMemberQuantity')
      else
        this.$store.commit('promoCart/decreaseMemberQuantity')
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.price {
  text-align: right;
  font-weight: normal;
}

.quantity {
  border: 1px solid grey;
  padding-left: 2px;
  padding-right: 2px;
}

.quantity:hover {
  border-color: $accent-blue;
}

.item-row {
  color: black;
}

.item-row:hover {
  background-color: $gray3;
  border-left: 5px solid $accent-blue;
  color: $accent-blue !important;
  cursor: pointer;
}

.item-row-active {
  background-color: $gray3 !important;
  border-left: 5px solid $accent-blue !important;
  color: $accent-blue !important;
}
</style>
